/**
 * Autify Mega Menu - Optimized JavaScript
 * Handles mobile menu toggle and navigation interactions
 */
(function() {
    'use strict';
    
    // Constants
    const MOBILE_BREAKPOINT = 1100;
    const SELECTORS = {
        toggleBtn: '.mobile-menu-toggle',
        menu: '.nav-parents',
        navParent: '.nav-parent.has-children',
        navLink: '.nav-parent.has-children > a',
        childContent: '.child-content',
        activeClass: 'active',
        menuOpenClass: 'menu-open'
    };
    
    // Cache DOM elements
    let toggleBtn, menu;
    
    /**
     * Initialize the mega menu functionality
     */
    function init() {
        // Cache frequently used DOM elements
        toggleBtn = document.querySelector(SELECTORS.toggleBtn);
        menu = document.querySelector(SELECTORS.menu);
        
        // Early return if essential elements not found
        if (!toggleBtn || !menu) {
            console.warn('Autify Mega Menu: Required elements not found');
            return;
        }
        
        // Initialize all features
        initMobileToggle();
        initNavigationHandlers();
        initChildContentAnimation();
    }
    
    /**
     * Initialize mobile menu toggle functionality
     */
    function initMobileToggle() {
        toggleBtn.addEventListener('click', handleMobileToggle);
    }
    
    /**
     * Handle mobile menu toggle click
     */
    function handleMobileToggle() {
        menu.classList.toggle(SELECTORS.menuOpenClass);
        toggleBtn.classList.toggle(SELECTORS.activeClass);
    }
    
    /**
     * Initialize navigation click handlers using event delegation
     */
    function initNavigationHandlers() {
        menu.addEventListener('click', handleNavigationClick);
    }
    
    /**
     * Handle navigation clicks with event delegation
     * @param {Event} event - The click event
     */
    function handleNavigationClick(event) {
        const target = event.target;
        
        // Check if clicked element is a navigation link
        if (!target.matches(SELECTORS.navLink)) return;
        
        // Only handle on mobile devices
        if (window.innerWidth > MOBILE_BREAKPOINT) return;
        
        event.preventDefault();
        
        const clickedParent = target.parentElement;
        if (!clickedParent) return;
        
        const isActive = clickedParent.classList.contains(SELECTORS.activeClass);
        
        // Close all other active parents
        closeAllActiveParents();
        
        // Toggle current parent
        if (!isActive) {
            clickedParent.classList.add(SELECTORS.activeClass);
        }
    }
    
    /**
     * Close all active parent navigation items
     */
    function closeAllActiveParents() {
        const activeParents = menu.querySelectorAll(`${SELECTORS.navParent}.${SELECTORS.activeClass}`);
        activeParents.forEach(parent => {
            parent.classList.remove(SELECTORS.activeClass);
        });
    }
    
    /**
     * Initialize child content animation by setting CSS custom properties
     */
    function initChildContentAnimation() {
        const childMenus = document.querySelectorAll(SELECTORS.childContent);
        
        childMenus.forEach(menu => {
            const listItems = menu.querySelectorAll('li');
            listItems.forEach((item, index) => {
                item.style.setProperty('--i', index + 1);
            });
        });
        
        // Add animation properties to image columns inside child wrapper inner
        const childWrapperInner = document.querySelectorAll('.child-wrapper-inner');
        childWrapperInner.forEach(wrapper => {
            const imageColumns = wrapper.querySelectorAll('.image-column');
            imageColumns.forEach((column, index) => {
                column.style.setProperty('--i', index + 1);
            });
        });
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
})();